<template>
  <div id="app">
    <v-app id="inspire">
      <v-content style="height: 100%; background-color: #626264">
        <div align="center">
          <br>
          <img src="../../assets/logo.png" style="width: 140px;">
          <br>
          <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR7131bUSTY2cu31W4p3UJj64VOuKpavm9uhA&usqp=CAU" style="width: 50px" alt="">
          <br>
          Hola, Valeria 1234
        </div>
          <v-layout align-center >
            <v-flex>
              <v-container>
                <v-row dense>
                  <v-col cols="12">
                    <v-card @click="$router.push('/device');"
                        color="#4e474c"
                        dark
                    >
                      <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                          <span style="padding-left:5px; font-size: 14px" class="yellowTuGps">Ubicación Mapa Acciones</span>
                        </v-flex>
                      </v-layout>
                      <v-card-actions>
                        <div>
                          <ul>
                            <li>
                              <td width="80%">
                                <span style="font-size: 12px">Bloquea, desbloquea y administra tus dispositivos.</span>
                              </td>

                            </li>
                          </ul>
                        </div>
                      </v-card-actions>
                    </v-card>
                    <div style="height: 5px"></div>
                    <v-card  @click="$router.push('/configuration');"
                        color="#4e474c"
                        dark

                    >
                      <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                          <span style="padding-left:5px; font-size: 14px" class="yellowTuGps">Alertas</span>
                        </v-flex>
                      </v-layout>
                      <v-card-actions>
                        <div>
                          <ul id="example-1">
                            <li>
                              <td width="80%">
                                <span style="font-size: 12px">Te avisaremos si algo no está bien con tu dispositivo</span>
                              </td>

                            </li>
                          </ul>
                        </div>
                      </v-card-actions>
                    </v-card>
                    <div style="height: 5px"></div>
                    <v-card
                        color="#4e474c"
                        dark
                    >
                      <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                          <span style="padding-left:5px; font-size: 14px" class="yellowTuGps">Reportes</span>
                        </v-flex>
                      </v-layout>
                      <v-card-actions>
                        <div>
                          <ul id="example-1">
                            <li>
                              <td width="80%">
                                <span style="font-size: 12px">Visualiza y exporta los reportes de tus dispositivos</span>
                              </td>

                            </li>
                          </ul>
                        </div>
                      </v-card-actions>
                    </v-card>
                    <div style="height: 5px"></div>
                    <v-card
                        color="#4e474c"
                        dark
                    >
                      <v-layout>
                        <v-flex xs12 sm10 offset-sm1>
                          <span style="padding-left:5px; font-size: 14px" class="yellowTuGps">Perfil</span>
                        </v-flex>
                      </v-layout>
                      <v-card-actions>
                        <div>
                          <ul id="example-1">
                            <li>
                              <td width="80%">
                                <span style="font-size: 12px">Personaliza tu foto de perfil</span>

                              </td>

                            </li>
                          </ul>
                        </div>
                      </v-card-actions>
                    </v-card>
                    <div style="height: 5px"></div>
                    <v-card
                        color="#4e474c"
                        dark
                    >
                      <v-layout>
                          <span style="padding-left:5px; font-size: 14px" class="yellowTuGps">Enviar comentarios</span>
                      </v-layout>
                      <v-card-actions>
                        <div>
                          <ul>
                            <li>
                              <td width="80%">
                                <span style="font-size: 12px">Reporta incidentes con la app o cualquier comentario que quieras enviarnos</span>
                              </td>

                            </li>
                          </ul>
                        </div>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
                <br>
                <v-btn color="primary" class="btn-rounded" large block><v-icon>call</v-icon>Llamar a TU G.P.S.</v-btn>
                <v-btn color="primary" class="btn-rounded" large block>Cerrar Sesión</v-btn>

              </v-container>
            </v-flex>
          </v-layout>
          <!--MODAL PARA INGRESAR EL CORREO Y RECUPERAR LA CONTRASEÑA.-->
          <v-dialog v-model="dialogPassword" max-width="500px">-->
            <v-card>
              <div>
                <div class="headline">
                  <v-card-title primary-title>Recuperar Contraseña</v-card-title>
                </div>
              </div>
              <v-card-text>
                <v-form v-model="valid">
                  Ingrese su correo electrónico para recuperar su contraseña
                  <v-text-field prepend-icon="email" :rules="emailRules" name="Correo electrónico" label="Correo electrónico" v-model="mailResetPassword"></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="grey darken-4" flat  :disabled="!valid" @click="requestPasswordReset">Enviar</v-btn>
                <v-btn color="grey darken-1" flat @click.stop="dialogPassword=false">Cancelar</v-btn>
              </v-card-actions>
            </v-card>
            <v-alert v-model="alert" color="error" dismissible>{{error}}</v-alert>
          </v-dialog>
      </v-content>
    </v-app>
  </div>
</template>

<script>
  export default {
    name: 'Login',
    data () {
      return {
        valid:false,
        show: false,
        username: '',
        password: '',
        mailResetPassword: '',
        dialogPassword: false,
        dialogPasswordSuccess: false,
        error: "",
        alert: false,
        emailRules: [
          v => !!v || 'El email es requerido',
          v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El email debe ser valido'
        ],
        items: [
          {
            color: '#1F7087',
            src: 'https://cdn.vuetifyjs.com/images/cards/foster.jpg',
            title: 'Supermodel',
            artist: 'Foster the People',
          },
          {
            color: '#952175',
            src: 'https://cdn.vuetifyjs.com/images/cards/halcyon.png',
            title: 'Halcyon Days',
            artist: 'Ellie Goulding',
          },
        ],
      }
    },
    methods: {
      login () {
        this.$store.dispatch('loadUsuario', {username: this.username, password: this.password}).then(response => {
        }, error => {
          this.$store.state.progress = false
          this.$store.state.dialogError = true
        })
      },
      openDialogRequestPasswordReset(){
        this.error= ""
        this.alert= false
        this.mailResetPassword= ""
      },
      requestPasswordReset () {
        if(this.checkFormResetPassword()){
          this.$store.dispatch('requestPasswordReset', {mail: this.mailResetPassword, host: 'admin'}).then(response => {
          })
        }
        this.dialogPassword = false
      },
      cancelar(){
        this.username=""
        this.password=""
      },
      checkFormResetPassword(){
        if(this.mailResetPassword===""){
          this.error= "Debe ingresar el usuario para recuperar la contraseña"
          this.alert=true
          return false
        }
        return true
      }
    }
  }
</script>

<style lang="css" scoped>
li{
  list-style:none;
}
</style>



// WEBPACK FOOTER //
// src/components/login/Menu.vue